import { ApiService } from '@lsq-frontend/angular-shared/api-service';

export abstract class ReportCenterApiService<TRequest, TResponse> extends ApiService<
    TRequest,
    TResponse
> {
    public serviceName = 'reportCenter';

    public get endpointUrl(): string {
        const serviceUrl = this._settings.httpApiServiceNameUrlMap[
            this.serviceName || this._settings.httpApiDefaultServiceName
        ];
        if (this.serviceName && !serviceUrl) {
            throw new Error(
                `No URL was found matching "${this.serviceName}" in SETTINGS.httpApiServiceNameUrlMap.`
            );
        }

        return `${serviceUrl}/${this.endpointName}`;
    }
}
